(() => {
  if (window.bhgProductCro) return;
  window.bhgProductCro = true;

  let pending = false;
  const sections = new Set();



  // Mobile purchase order: gallery, heading/reviews, price, selector and purchase, supporting details.
  // Keep original nodes and anchors so desktop and app controls stay intact.
  const mobileOrder = window.matchMedia('(max-width: 749.98px)');
  const orderOrigins = new WeakMap();

  function moveForMobile(node, target) {
    if (!node || !target || node.parentNode !== target.parentNode ||
        node.nextElementSibling !== target) {
      if (!node || !target) return;
      if (!orderOrigins.has(node)) {
        const origin = document.createComment('BHG mobile order: original position');
        node.before(origin);
        orderOrigins.set(node, origin);
      }
      target.before(node);
    }
  }

  function moveAfterForMobile(node, target) {
    if (!node || !target || node === target || target.nextElementSibling === node) return;
    if (!orderOrigins.has(node)) {
      const origin = document.createComment('BHG mobile order: original position');
      node.before(origin);
      orderOrigins.set(node, origin);
    }
    target.after(node);
  }

  function updateMobileOrder(section) {
    const info = section.querySelector('product-info[data-bhg-mobile-order]');
    const primary = info?.querySelector('[data-bhg-primary-info]');
    if (!primary) return;

    const heading = info.querySelector('[data-bhg-product-heading]');
    const benefits = [...primary.querySelectorAll(':scope > .bhg-product-benefits, :scope > .bhg-product-details')];
    if (mobileOrder.matches) {
      if (heading && primary.firstElementChild !== heading) {
        moveForMobile(heading, primary.firstElementChild);
      }
      // Keep the selector and the original purchase form together, then supporting details.
      let purchase = primary.querySelector('.product-form--buy-buttons');
      while (purchase && purchase.parentElement !== primary) purchase = purchase.parentElement;
      let target = primary.querySelector(':scope > .bhg-product-policy') || purchase;
      if (target) {
        benefits.forEach(benefit => {
          moveAfterForMobile(benefit, target);
          target = benefit;
        });
      }
    } else {
      [heading, ...benefits].filter(Boolean).forEach(node => {
        const origin = orderOrigins.get(node);
        if (origin?.isConnected) {
          origin.after(node);
          origin.remove();
          orderOrigins.delete(node);
        }
      });
    }
  }

  function updateOfferTitles(section) {
    const info = section.querySelector('product-info[data-bhg-display-title]');
    const original = info?.dataset.productTitle?.trim();
    const short = info?.dataset.bhgDisplayTitle?.trim();
    if (!original || !short || original === short) return;

    const normalize = value => value.replace(/\s+/g, ' ').trim();
    section.querySelectorAll('.rapi-bundles__bar-title').forEach(title => {
      const candidates = [...title.querySelectorAll('p, span'), title];
      const target = candidates.find(element =>
        element.childElementCount === 0 &&
        normalize(element.textContent).endsWith(normalize(original))
      );
      if (!target) return;

      const text = normalize(target.textContent);
      const prefix = text.slice(0, text.length - normalize(original).length);
      if (prefix && !/^(?:x\s*\d+|\d+\s*(?:Jars?|Packs?|Units?|Boxes?))\s*[-–—]?\s*$/i.test(prefix)) return;

      const label = prefix + short;
      if (target.textContent !== label) target.textContent = label;
    });
  }



  // Keep the full lunchbox selection readable beside Rapi's native dropdown.
  function updateLunchboxSelection(section) {
    const info = section.querySelector('product-info[data-product-id="8235091689506"]');
    if (!info) return;
    info.querySelectorAll('select.rapi-bundles__bar-variant-select[data-variantname="Style"]').forEach(select => {
      let label = select.nextElementSibling;
      if (!label?.classList.contains('bhg-selected-style')) {
        label = document.createElement('p');
        label.className = 'bhg-selected-style';
        select.after(label);
      }
      const option = select.selectedOptions[0];
      const text = option ? 'Selected style: ' + option.textContent.trim() : '';
      if (label.textContent !== text) label.textContent = text;
      if (label.hidden !== !text) label.hidden = !text;
    });
  }

  const choiceFocus = new WeakMap();
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-bhg-visual-offer] [data-bhg-variant-title]');
    if (!choice || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const offer = choice.closest('[data-bhg-visual-offer]');
    const info = choice.closest('product-info');
    if (offer.dataset.failed === 'true') return;
    const input = [...info.querySelectorAll('variant-selects input[type="radio"]')].find(input => input.value === choice.dataset.bhgVariantTitle);
    if (!input) return;
    event.preventDefault();
    if (offer.getAttribute('aria-busy') === 'true' || input.checked) return;
    choiceFocus.set(info, choice.id);
    offer.setAttribute('aria-busy', 'true');
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const variantStates = new WeakMap();

  document.addEventListener('bhg:variant-state', event => {
    variantStates.set(event.target, event.detail.variant);
    if (event.detail.variant) queueMicrotask(() => {
      const info = event.target;
      const initial = info.querySelector('[data-bhg-initial-variant]');
      if (initial && info.querySelector('[data-bhg-visual-offer]')) initial.textContent = JSON.stringify(event.detail.variant);
      const focusId = choiceFocus.get(info);
      if (focusId) {
        document.getElementById(focusId)?.focus({ preventScroll: true });
        choiceFocus.delete(info);
      }
    });
    schedule();
  });

  function updateRestock(section) {
    const info = section.querySelector('product-info');
    if (!info?.querySelector('[data-bhg-notify-button]')) return;
    let variant = variantStates.get(info);
    if (!variantStates.has(info)) {
      try {
        variant = JSON.parse(info.querySelector('variant-selects [data-selected-variant], [data-bhg-initial-variant]')?.textContent || 'null');
      } catch { variant = null; }
    }
    const soldOut = !!variant && variant.available === false;
    const main = info.querySelector('.product.grid .product-form--buy-buttons [id^="ProductSubmitButton-"]');
    const sticky = info.querySelector('.sticky-cta__button');
    [main?.parentElement, sticky].filter(Boolean).forEach(row => {
      let button = row.querySelector('[data-bhg-variant-notify]');
      if (!button && soldOut) {
        button = info.querySelector('[data-bhg-notify-button]').content.firstElementChild.cloneNode(true);
        row.append(button);
        row.classList.add('bhg-restock-actions');
      }
      if (button) {
        if (button.hidden === soldOut) button.hidden = !soldOut;
        if (soldOut) button.dataset.variantId = String(variant.id);
      }
      if (row.classList.contains('bhg-restock-actions') !== soldOut) row.classList.toggle('bhg-restock-actions', soldOut);
    });
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bhg-variant-notify]');
    if (!trigger) return;
    const info = trigger.closest('product-info');
    const template = info?.querySelector('template[data-bhg-restock-template]');
    if (!template || trigger.hidden) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'bhg-variant-restock-dialog color-scheme-2 gradient';
    dialog.innerHTML = '<button type="button" class="bhg-restock-close"><span aria-hidden="true">×</span></button>';
    const close = dialog.firstElementChild;
    close.setAttribute('aria-label', document.querySelector('[id^="ModalClose-"][aria-label]')?.getAttribute('aria-label') || 'Close');
    dialog.append(template.content.cloneNode(true));
    dialog.querySelectorAll('[id]').forEach(element => {
      const previous = element.id;
      element.id = previous + '-dialog';
      dialog.querySelectorAll('label[for]').forEach(label => {
        if (label.htmlFor === previous) label.htmlFor = element.id;
      });
    });
    const heading = dialog.querySelector('h2');
    heading.id = 'BHGVariantRestockHeading';
    dialog.setAttribute('aria-labelledby', heading.id);
    const select = dialog.querySelector('select[name="contact[Variant]"]');
    const option = select?.querySelector('option[data-variant-id="' + trigger.dataset.variantId + '"]');
    if (option) select.value = option.value;
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { dialog.remove(); trigger.focus(); }, { once: true });
    dialog.addEventListener('click', event => { if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    } });
    dialog.showModal();
    dialog.querySelector('input[type="email"]')?.focus();
  });

  function update() {
    pending = false;
    const footer = document.querySelector('footer.footer, footer, .section-footer');
    const footerVisible = !!footer && footer.getClientRects().length > 0 &&
      footer.getBoundingClientRect().top < window.innerHeight;
    let stickyHeight = 0;

    sections.forEach(section => {
      if (!section.isConnected) {
        sections.delete(section);
        return;
      }

      updateMobileOrder(section);
      updateOfferTitles(section);
      updateLunchboxSelection(section);
      updateRestock(section);

      const mainButton = section.querySelector('.product.grid .product-form--buy-buttons [id^="ProductSubmitButton-"]');
      const sticky = section.querySelector('.sticky-cta');

      if (sticky) {
        const visible = !!mainButton && mainButton.getClientRects().length > 0 &&
          mainButton.getBoundingClientRect().bottom <= 0 && !footerVisible;
        if (sticky.hasAttribute('data-bhg-visible') !== visible) {
          sticky.toggleAttribute('data-bhg-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
        }
        if (visible) stickyHeight = Math.max(stickyHeight, sticky.getBoundingClientRect().height);
      }

      section.querySelectorAll('.product.grid .product-form__buttons > .flex').forEach(row => {
        const quantityWrapper = row.querySelector(':scope > .pb-1');
        const quantity = quantityWrapper?.querySelector('quantity-input');
        const emptyQuantity = !!quantityWrapper && (!quantity ||
          quantity.getClientRects().length === 0 || quantity.getBoundingClientRect().width === 0);
        if (row.hasAttribute('data-bhg-empty-quantity') !== emptyQuantity) {
          row.toggleAttribute('data-bhg-empty-quantity', emptyQuantity);
        }
      });
    });

    const value = `${stickyHeight}px`;
    if (document.documentElement.style.getPropertyValue('--bhg-sticky-height') !== value) {
      document.documentElement.style.setProperty('--bhg-sticky-height', value);
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }

  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const mutationObserver = new MutationObserver(schedule);

  function discover() {
    document.querySelectorAll('.section-product-page').forEach(section => {
      if (sections.has(section)) return;
      sections.add(section);
      mutationObserver.observe(section, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'disabled']
      });
      resizeObserver?.observe(section);
      section.querySelectorAll('.sticky-cta, .product-form__buttons').forEach(element => resizeObserver?.observe(element));
    });
    schedule();
  }

  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', discover);
  document.addEventListener('shopify:section:load', discover);
  document.addEventListener('product-info:loaded', discover);
  document.addEventListener('change', event => {
    const selector = event.target.closest?.('[data-bhg-style-select]');
    if (!selector?.value) return;
    event.stopImmediatePropagation();
    window.location.assign(selector.value);
  }, true);
  document.addEventListener('change', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, { once: true });
  else discover();
})();

